module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 002.c94c2bd0.jpg";